<div class="opciones">
    <div class="col-md-12">
        <p>
            Elija la opción hacia donde quiere ir.
        </p>
    </div>
    <div class="col-md-12" style="margin-bottom: 10px;">
        <button mat-raised-button color="primary" (click)="sign('totem-busqueda-direccion')">Búsqueda de propiedad</button>
    </div>
    
    
</div>